import { ConvexReactClient } from "convex/react";

const convexUrl = import.meta.env.VITE_CONVEX_URL;
if (!convexUrl) {
  throw new Error(
    "Missing VITE_CONVEX_URL — run `bunx convex dev` to bootstrap your deployment.",
  );
}

export const convex = new ConvexReactClient(convexUrl);
